export default __webpack_public_path__ + "static/media/dk2.4bdf871a.jpg";